import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { deleteRole } from 'api/role.service';
import { notificationActions } from 'redux/notification/notification.slice';

export const ROLE_DELETE_STORE_NAME = 'roleDelete';

export const deleteRoles = createAsyncThunk(
  `${ROLE_DELETE_STORE_NAME}/delete`,
  async (payload: { projectId: string, roleCode: string }, thunkAPI) => {
    const { projectId, roleCode } = payload;
    await deleteRole(projectId, roleCode);
    thunkAPI.dispatch(notificationActions.addSuccess({ messageId: 'notification.RoleDelete.success' }));
  },
);

export interface RoleDeleteState {
  processing: boolean
  succeeded: boolean
  error: any
}

export const initialRoleDeleteState: RoleDeleteState = {
  processing: false,
  succeeded: false,
  error: null,
};

export const roleDeleteSlice = createSlice({
  name: ROLE_DELETE_STORE_NAME,
  initialState: initialRoleDeleteState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(deleteRoles.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(deleteRoles.fulfilled, (state) => {
      state.processing = false;
      state.succeeded = true;
    });
    builder.addCase(deleteRoles.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const roleDeleteActions = {
  ...roleDeleteSlice.actions,
  deleteRoles,
};

export default roleDeleteSlice.reducer;
